import React from 'react'
import PropTypes from 'prop-types'

function DenaliLogo ({ size, flat }) {
  if (flat) {
    return (
      <svg
        id='denali_ai_logo'
        data-name='Denali AI Logo'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 117.23 67.26'
        style={{
          width: size,
          height: size,
          fill: 'white'
        }}
      >
        <g data-name='denali-ai-body'>
          <g>
            <polygon
              className='ai_dot' points='71.42 17.91 77.89 9.57 71.36 0 65.39 8.61 71.42 17.91'
            />
            <polygon
              className='ai_body'
              points='76.12 25.16 97.75 58.5 84.49 58.5 46.47 0 0 67.26 39.36 67.26 53.42 45.87 47.55 36.82 33.4 58.5 17.92 58.5 46.18 17.43 78.49 67.26 117.23 67.26 82.72 16.66 76.12 25.16'
            />
          </g>
        </g>
      </svg>
    )
  }

  return (
    <svg
      id='denali_ai_logo'
      data-name='Denali AI Logo'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 117.23 67.26'
      style={{
        width: size,
        height: size,
        fill: 'url(#denali-ai-gradient)'
      }}
    >
      <defs>
        <linearGradient id='denali-ai-gradient' gradientTransform='rotate(0)'>
          <stop offset='0%' stopColor='var(--palette-purple-500)' />
          <stop offset='100%' stopColor='var(--palette-blue-500)' />
          <animateTransform
            attributeName='gradientTransform'
            type='rotate'
            from='0 0.5 0.5'
            to='360 0.5 0.5'
            dur='8s'
            repeatCount='1'
          />
        </linearGradient>
      </defs>
      <g data-name='denali-ai-body'>
        <g>
          <polygon
            className='ai_dot' points='71.42 17.91 77.89 9.57 71.36 0 65.39 8.61 71.42 17.91'
          />
          <polygon
            className='ai_body'
            points='76.12 25.16 97.75 58.5 84.49 58.5 46.47 0 0 67.26 39.36 67.26 53.42 45.87 47.55 36.82 33.4 58.5 17.92 58.5 46.18 17.43 78.49 67.26 117.23 67.26 82.72 16.66 76.12 25.16'
          />
        </g>
      </g>
    </svg>
  )
}

DenaliLogo.propTypes = {
  size: PropTypes.string,
  flat: PropTypes.bool
}

DenaliLogo.defaultProps = {
  size: '250px',
  flat: false
}

export default DenaliLogo
